/* eslint no-useless-escape: 0 */

module.exports = {
  addressFormat: 'addressLine1,addressLine2,city,state,postalCode',
  NACOfranOwnerId: 220,
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      addressVerificationRequired: false,
      isShippingAddressRequired: true,
      hasInstallments: true,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '4',
      refId: '1',
      name: '@Work eTools',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '8',
      refId: '1',
      name: 'eTools',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '14',
      refId: '1',
      name: 'Online iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '22',
      refId: '0',
      name: 'Digital Group Coaching',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex:
        "^[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€]+[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*$",
    },
    addressLine2: {
      regex:
        "^$|^[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€]+[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*$",
    },
    city: {
      regex:
        '^[a-zA-Z\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00C7\u00E7\u20AC. -]*[a-zA-Z\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00C7\u00E7\u20AC]+[a-zA-Z\u00C0\u00C2\u00C4\u00C8\u00C9\u00CA\u00CB\u00CE\u00CF\u00D4\u0152\u00D9\u00DB\u00DC\u0178\u00E0\u00E2\u00E4\u00E8\u00E9\u00EA\u00EB\u00EE\u00EF\u00F4\u0153\u00F9\u00FB\u00FC\u00FF\u00C7\u00E7\u20AC. -]*$',
    },
    state: {
      required: true,
    },
    postalCode: {
      type: 'string',
      min: 6,
      max: 7,
      regex: '^[a-zA-Z]{1}\\d{1}[a-zA-Z]{1} *\\d{1}[a-zA-Z]{1}\\d{1}$',
      regexFlags: '',
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
  },
  payment: {
    modes: ['FLEX', 'CC', 'PP'],
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
      { id: 3, tid: 23, name: 'AMERICAN EXPRESS', ccName: 'AMERICAN EXPRESS' },
    ],
  },
};
